const EyeOpen = () => {
    return (
        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 4.25C4.91682 4.25 2.64832 7.42569 1.84165 8.83729C1.67616 9.12689 1.59342 9.27169 1.60253 9.4877C1.61164 9.70371 1.70893 9.84485 1.9035 10.1271C2.86365 11.5202 5.47042 14.75 9 14.75C12.5296 14.75 15.1364 11.5202 16.0965 10.1271C16.2911 9.84485 16.3884 9.70371 16.3975 9.4877C16.4066 9.27169 16.3238 9.12689 16.1583 8.83729C15.3517 7.42569 13.0832 4.25 9 4.25Z" stroke="#818181" strokeWidth="1.5" />
            <circle cx="9" cy="9.5" r="3" fill="#818181" />
        </svg>


    )
}

export default EyeOpen